<div class="address" *ngIf="_address">
	<span class="address-icon">
		<img src="../assets/img/icons/icon-map-pin-purple.svg" />
	</span>
	<span class="address-label">{{ _address }}</span>
</div>
<div class="change-address">
	<a (click)="changeAddress()">Change</a>
</div>
